import Validator from 'validator';
import notification from 'notification-js';

export const validateRegisterForm = function(form) {
  let companyName = form.getElementsByClassName('companyName')[0];
  let loginUsername = form.getElementsByClassName('loginUsername')[0];
  let firstname = form.getElementsByClassName('firstname')[0];
  let surname = form.getElementsByClassName('surname')[0];
  let email = form.getElementsByClassName('email')[0];
  let loginPassword = form.getElementsByClassName('loginPassword')[0];
  let confirmPassword = form.getElementsByClassName('confirmPassword')[0];

  if (Validator.isNull(companyName.value) ||
      Validator.isNull(loginUsername.value) ||
      Validator.isNull(firstname.value) ||
      Validator.isNull(surname.value) ||
      Validator.isNull(email.value) ||
      Validator.isNull(loginPassword.value) ||
      Validator.isNull(confirmPassword.value)) {
    notification.notify( 'error', 'Please make sure all fields are entered', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if (!Validator.isEmail(email.value)) {
    notification.notify( 'error', 'Please enter a valid email address', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if (loginPassword.value !== confirmPassword.value) {
    notification.notify( 'error', 'The confirm password does not match', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if (validatePassword(loginPassword.value)) {
    return true;
  }

}

export const validatePassword = function(passwordValue)  {
  if (!Validator.isLength(passwordValue, {min:8, max: undefined})) {
    notification.notify( 'error', 'The password needs to be at least 8 characters', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if (!( passwordValue.match(/[a-z]/) ) ) {
    notification.notify( 'error', 'Password must contain at least one smallcase character', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if ( !( passwordValue.match(/[A-Z]/) ) ) {
    notification.notify( 'error', 'Password must contain at least one capital case character', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if ( !( passwordValue.match(/[A-Z]/) ) ) {
    notification.notify( 'error', 'Password must contain at least one digit', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  if(!passwordValue.match(/[^a-zA-Z0-9 ]/)) {
    notification.notify( 'error', 'Password must contain at least one special character', {
      notification: {position: [ 'right', 'top' ]}
    });
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/Validation.js